import { all, isEmpty } from "ramda";
export function calculateLeftMargin(w) {
    var calculatedLeftMargin = (w - 850) / 2;
    return calculatedLeftMargin > 0 ? calculatedLeftMargin + "px" : "400px";
}
function isValidParam(val) {
    return val && !isEmpty(val);
}
export function settingsIncludesRequiredValues(settings) {
    var name = settings.name, storePrettyUrl = settings.storePrettyUrl, ugMerchantKey = settings.ugMerchantKey;
    return all(isValidParam, [name, storePrettyUrl, ugMerchantKey]);
}
